import styled from 'styled-components/macro'
import { motion } from 'framer-motion'

export const Content = styled(motion.div)`
    width: 100%;
`

export const Title = styled(motion.h2)`
    // border-bottom: 1px solid black;
    padding-bottom: 1rem;

    @media all and (max-width: 650px) {
        padding-bottom: .5rem;
    }    
`

export const DetallesContainer = styled.div`
    width: 100%;
`

export const CounterContainer = styled(motion.div)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    font-weight: bold;
`

export const Note = styled(motion.p)`

    margin: 0;

    @media screen and (max-width: 650px){
        font-size: .5rem;
    }
`

export const Counter = styled(motion.p)`
    font-size: 3rem;
    margin: 0;

    @media screen and (max-width: 1050px){
        font-size: calc(1rem + 2vw) !important;
    }
`

export const ResetBudget = styled(motion.button)`
    border: none;
    cursor: pointer;
`